import React from "react";
import Navbar from "../components/Navbar";
import { reloadForNewWebVersion } from "../utils/versionRefresh";
import "../styles/ErrorScreen.css";

// central config for different error types
const ERROR_CONFIG = {
  account_blocked: {
    img: "/assets/images/account_blocked.svg",
    title: "Account Blocked!",
    message:
      "You can't access that resource as you are blocked from using our app, please contact support for further assistance.",
    button: "REFRESH",
  },
  app_update: {
    img: "/assets/images/account_blocked.svg",
    title: "Update Required",
    message:
      "This page is out of date. Refresh to load the latest version.",
    button: "REFRESH",
  },
  server_error: {
    img: "/assets/images/server_error.svg",
    title: "Server Error!",
    message:
      "Something went wrong on our end. Please try again later.",
    button: "REFRESH",
  },
  course_already_purchased: {
    img: "/assets/images/success.svg",
    title: "Course Already Purchased!",
    message:
      "You have already purchased the course, please click the below button to open the G9 Lexia App to continue learning.",
    button: "OPEN APP",
  },
  "400": {
    img: "/assets/images/server_error.svg",
    title: "Client Side Error!",
    message:
      "Auto Generated.",
    button: "OPEN APP",
  },
};

export default function ErrorScreen({ type = "server_error", onAction, onMessage, navRequired = true }) {
  // const navigate = useNavigate();
  const cfg = ERROR_CONFIG[type] || ERROR_CONFIG.server_error;

  const handleClick = () => {
    if (onAction) onAction();
    else if (type === "app_update") reloadForNewWebVersion({ force: true });
    else window.location.reload();
  };

  return (
    <div className="error-wrapper">
      {navRequired && <Navbar />}
      <img src={cfg.img} alt={cfg.title} className="error-illustration" />
      <h2 className="error-title">{cfg.title}</h2>
      <p className="error-message">{(onMessage && onMessage !== "") ? onMessage : cfg.message}</p>
      <button className="error-button" onClick={handleClick}>
        {cfg.button}
      </button>
    </div>
  );
}